"use client";

import { createContext, useContext, type ReactNode } from "react";
import type { UserIdentity } from "@supabase/supabase-js";

export type AccountDataContextValue = {
  email: string | null;
  name: string | null;
  identities: UserIdentity[];
  hasPassword: boolean;
  hasMagicLink: boolean;
  isLoading: boolean;
  setName: (name: string | null) => void;
  setHasPassword: (value: boolean) => void;
  setHasMagicLink: (value: boolean) => void;
  setIdentities: (value: UserIdentity[]) => void;
  refreshUser: () => Promise<void>;
  refreshIdentities: () => Promise<void>;
};

const AccountDataContext = createContext<AccountDataContextValue | null>(null);

export function AccountDataProvider({
  value,
  children,
}: {
  value: AccountDataContextValue;
  children: ReactNode;
}) {
  return (
    <AccountDataContext.Provider value={value}>
      {children}
    </AccountDataContext.Provider>
  );
}

export function useAccountData() {
  const context = useContext(AccountDataContext);
  if (!context) {
    throw new Error("useAccountData must be used within AccountDataProvider.");
  }
  return context;
}
